import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { createSelectorRx, upDownItem } from "keautils";
import { RutaSucursalTrasbordoEdit } from "./edit";
import { RutaSucursalTrasbordoDTO } from "app/models/requireme";

const EditModal = RutaSucursalTrasbordoEdit;
type Entity = RutaSucursalTrasbordoDTO;
export interface Props {
    value: Entity[];
    onChange: (x: Entity[]) => void;
    readonly?: boolean;
    error?: kea.FieldError;
}

export interface BotonesListaDeps {
    onEdit: (x: Entity) => void;
    onBorrar: (x: Entity) => void;
}

/**Obtiene las columnas del grid */
function columnas(deps: BotonesListaDeps): kea.Grid2Column<Entity>[] {
    const botones = kea.columnaBotones([
        ...kea.columnaBotonesDefault(deps),
    ]);
    return [
        botones,
        { title: "Sucursal", cell: x => ({ data: x.NombreSucursal }) },
    ];
}

/**Establece las propiedades de descripcion para ser mostradas correctamente en el listado */
async function setDescripciones(x: Entity): Promise<Entity> {
    const sucursal = await resources.Sucursal.getMemo(x.IdSucursal);
    return { ...x, NombreSucursal: sucursal.DescripcionSucursal };
}

/**
* Listado de Punto
*/
export class TrasbordoList extends React.PureComponent<Props> {
    private modals = kea.createModalManager();
    onAgregar = async () => {
        const result = await this.modals.showModal(EditModal, undefined, {} as Entity);;
        if (result.result) {
            const newItem = await setDescripciones(result.value);
            const oldList = this.props.value;
            await this.props.onChange([...oldList, newItem]);
        }
    }

    onEdit = async (item: Entity) => {
        const result = await this.modals.showModal(EditModal, undefined, item);
        if (result.result) {
            const newItem = await setDescripciones(result.value);
            const oldList = this.props.value;
            await this.props.onChange(oldList.map(x => x == item ? newItem : x));
        }
    }

    onBorrar = async (item: Entity) => {
        const ok = await kea.yesno("¿Borrar elemento?", item.NombreSucursal);
        if (ok) {
            const oldList = this.props.value;
            await this.props.onChange(oldList.filter(x => x != item));
        }
    }

    render() {
        const cols = columnas(this);
        return (
            <div>
                <kea.AgregarButton onClick={this.onAgregar} />
                <kea.Grid2 items={this.props.value} columnas={cols} />
                {this.modals.component}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/rutas/edit/trasbordos/index.tsx